import { AppUriPath } from "app/AppRoutes";
import { NavigateFunction } from "react-router-dom";

export const goBackNavigate = (path: typeof AppUriPath[keyof typeof AppUriPath], navigate: NavigateFunction) => {
    if (window.history.state && window.history.state.idx > 0) {
        navigate(-1);
    } else {
        navigate(path);
    }
};